import { AppData } from './app-data.service';
import { Router } from '@angular/router';
import { ApiRequestService } from './api-request.service';
import { StorageService } from './../../core/services/storage.service';
import { Injectable } from '@angular/core';
import { IdsService } from './ids.service';
import { LoaderService } from './loader.service';
import { isPlatform, Platform } from '@ionic/angular';
// import { UniqueDeviceID } from '@ionic-native/unique-device-id/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private storageService: StorageService,
    private apiRequestService: ApiRequestService,
    private router: Router,
    private idsService: IdsService,
    private platform:Platform,
    // private uniqueDeviceID: UniqueDeviceID,
    private device:Device,
    private loaderService: LoaderService) {

    if (this.isAuthenticated()) {
      this.reInitializeAppData();
      AppData.token.next(this.storageService.getItem('token'));
      AppData.isAuthenticated = true;
    } else {
      console.log('inside initApp');
      this.initializeAppData();
    }
    this.platform.ready().then(() => {
    this.getDeviceId();
  })

  
    // this.reInitializeAppData();

  }

  isAuthenticated() {
    return AppData.isAuthenticated && AppData.userId;
  }

  initializeAppData() {
    this.loaderService.hide();
    AppData.token.next(null);
    AppData.isAuthenticated = false;
    AppData.userInfoSub$.next(null);
    AppData.userIdSub$.next(null);
    AppData.bottomNavMobileIndSub$.next(0);
    AppData.selectedAddonsListSub$.next([]);
    AppData.yourPlateItemsSub$.next(null);
    AppData.plateItemCountSub$.next({ itemCount: 0, itemTotal: 0, outletName: '', outletLogo: '', outletId: '' });
    AppData.spInstructionsSub$.next('');
    // AppData.currentAddressSub$.next(null);
    AppData.cartIdSub$.next(null);

    // this.storageService.removeItem('currentLocation');
    // this.storageService.removeItem('cartId');
    // this.storageService.removeItem('token');
    // this.storageService.removeItem('userInfo');
    // this.storageService.removeItem('userId');
    // this.storageService.removeItem('yourPlateItem');
    // this.storageService.removeItem('spInstructions');
    // this.storageService.removeItem('selectAddonsList');
    const deviceIdStor = this.storageService.getItem('deviceId');
    this.storageService.clearStorage();
    AppData.deviceIdSub$.next(deviceIdStor);

  }

  reInitializeAppData() {
    console.log('re-init called');
    const currentUrlTree = this.router['location']['_platformLocation']['location']['pathname'];
    const routeItem = this.router['location']['_platformLocation']['location']['search']
    if (AppData.currentAddressObj === null) {
      this.router.navigate(['select-location']);
    } else if (currentUrlTree === '/welcome' || currentUrlTree === '/') {
      this.router.navigate(['/home']);
    } else {
      this.router.navigateByUrl(currentUrlTree + routeItem);
    }
    // if (currentUrlTree === '/select-location' || currentUrlTree === '/') {
    //   if (AppData.currentAddressObj !== null) {
    //     this.router.navigate(['/home']);
    //   } else {
    //     this.router.navigateByUrl(currentUrlTree + routeItem);
    //   }
    // }
  }
  getDeviceId() {
    if (this.storageService.getItem('deviceId') === '') {
      let deviceId = '';
        if (isPlatform('ios')) {
          if (this.device.uuid) {
            deviceId = 'ios-'+ this.device.uuid
          } else {
            deviceId = 'ios-'+ this.idsService.generate()
          }
        }
        // alert(this.device.uuid)    

      if (deviceId === undefined || deviceId === '') {
        console.log(this.idsService.generate())
        deviceId = isPlatform('ios') ? 'ios-' : 'android-' + this.idsService.generate();
      }
      AppData.deviceIdSub$.next(deviceId);
    }
  }

  getCartDataItems(type) {
    if (type === 'CART_ID') {
      this.apiRequestService.get('cartId', '?cartId=' + '').then((res) => {
        const responseData = res['body']['data'];
        this.storageService.setItem("cartId", responseData['cartId']);
        AppData.cartIdSub$.next(responseData['cartId']);
      });
    } else {
      this.apiRequestService.get('cartId', '?cartId=' + AppData.cartId).then((res) => {
        const responseData = res['body']['data'];
        console.log('---------->', responseData);
        if (responseData['outlets']) {
          AppData.yourPlateItemsSub$.next(JSON.parse(JSON.stringify(responseData)));
        }
      });
    }

  }

  async logOut() {
    console.log(AppData.userInfoData);
    if (AppData.userInfoData.mobile != 9123456780) {
      await this.apiRequestService.post('logout', {}).then((res) => {
        AppData.userInfoData = null;
        this.initializeAppData();
        this.router.navigate(['welcome']);
      }, (error => {
        AppData.userInfoData = null;
        this.initializeAppData();
        this.router.navigate(['welcome']);
      }));
    } else {
      this.loaderService.hide();
      this.initializeAppData();
      this.router.navigate(['welcome']);
    }
  }
}
